const languageDialog = {
  props: {
    dynamicClass: ".c-language-dialog.dynamicLoading",
    className: "language-dialog",
    classLanguageDialog: "language-dialog-container-JS",
    classTargetLanguage: "target-language",
    classCurrentLanguage: "current-language",
    classSelectLanguage: "select-language",
    classDescriptionText: "language-dialog-desc",
    classNameAssociateSelect: "menu-content-associate-select",
    classBtn: "c-cta",
    classLanguageSelection: "language-selection",
    targetPlaceholder: "[targetlanguage]",
    currentPlaceholder: "[currentlanguage]",
    dataUrl: "data-url",
    locale: "data-locale",
    $buttonTarget: null,
    $descriptionText: null,
    $languageSelection: null,
    targetUrl: null,
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-languageDialog.css", this.props.dynamicClass);

    const baseFind = baseDom ? baseDom : document;
    const $component = baseFind.getElementsByClassName(this.props.classLanguageDialog);
    if (!$component || !$component[0]) {
      return;
    }

    this.props.$buttonTarget = document.getElementById(this.props.classTargetLanguage);
    this.props.$descriptionText = document.getElementById(this.props.classDescriptionText);
    this.props.$languageSelection = baseFind.getElementsByClassName(this.props.classLanguageSelection)[0];
  },

  update: function (data) {
    let countryCode, language;

    if (data) {
      const dataLanguage = data.hpcode ? data.hpcode.split("-") : "";
      countryCode = dataLanguage[1] ? dataLanguage[1] : "";
      language = dataLanguage[0] ? dataLanguage[0] : "";
    }

    if (!data && bcl.contextHub) {
      countryCode = bcl.contextHub.getItem("profile", "country_code");
      const $languageDiv = document.querySelector("[data-current-country-shop-selector=true]");
      if ($languageDiv) {
        language = $languageDiv.dataset.value;
      }
    }

    if (countryCode && language) {
      let targetLanguageLabel = "";
      const $targetLanguageDiv = document.querySelector("[data-country-shop-selector='" + countryCode.toLowerCase() + "']");
      if ($targetLanguageDiv) {
        targetLanguageLabel = $targetLanguageDiv.dataset.value;
      }

      if (this.props.$buttonTarget) {
        const $button = this.props.$buttonTarget.getElementsByClassName(this.props.classBtn);

        if ($button && $button[0]) {
          $button[0].text = this.replaceText($button[0].text, this.props.targetPlaceholder, targetLanguageLabel);
          $button[0].title = this.replaceText($button[0].title, this.props.targetPlaceholder, targetLanguageLabel);
        }
      }

      if (this.props.$descriptionText) {
        let text = this.props.$descriptionText.innerHTML;
        text = text.replace(this.props.targetPlaceholder, data && data.label ? data.label : targetLanguageLabel);
        text = text.replace(this.props.currentPlaceholder, data && data.currentLabel ? data.currentLabel : language);
        this.props.$descriptionText.innerHTML = text;
      }
    }

    this.initItems(data ? data : null);

    const redirect = bcl.u.getParameterByName("redirect");
    const url = window.location.href;

    if (this.props.targetUrl && redirect && redirect == "true") {
      let queryParams = "";
      queryParams = bcl.u.removeUrlParameter("redirect", url);
      if (queryParams) {
        window.location = this.props.targetUrl.split("?")[0] + "?" + queryParams;
      } else {
        window.location = this.props.targetUrl.replace("?redirect=true", "");
      }
    }
  },

  replaceText: function (text, placeHolder, replaceText) {
    return text.replace(placeHolder, replaceText);
  },

  initItems: function (data) {
    this.initCurrentItem(document.getElementById(this.props.classCurrentLanguage), data);
    this.initTargetItem(document.getElementById(this.props.classTargetLanguage), data);
    this.initSelectItem(document.getElementById(this.props.classSelectLanguage));
  },

  initTargetItem: function ($element, data) {
    const promise = new Promise((resolve) => {
      const countdown = setInterval(() => {
        const hpcode = this.getHpCode(data);
        if (hpcode) {
          clearInterval(countdown);
          resolve(hpcode);
        }
      }, 1000);
    });

    promise
      .then((hpcode) => {
        const targetUrl = this.getTargetUrl(hpcode);
        if (targetUrl) {
          $element.setAttribute(this.props.dataUrl, targetUrl);
          const $targetButton = $element.getElementsByClassName(this.props.classBtn);
          if ($targetButton && $targetButton[0]) {
            $targetButton[0].setAttribute("href", targetUrl);
            this.props.targetUrl = targetUrl;
            $targetButton[0].addEventListener("click", function () {
              bcl.u.addBhgLoading();
            });
          }
        }
      })
      .catch(function (reason) {
        console.error("ERROR PROMISE initTargetItem [" + reason + "]");
      });
  },

  getTargetUrl: function (hpcode) {
    const $targetLanguage = document.querySelector(".references-JS[data-hreflang=" + hpcode.toLowerCase() + "]");
    if ($targetLanguage) {
      return $targetLanguage.dataset.href + window.location.search;
    }
  },

  getHpCode: function (data) {
    if (data && data.hpcode) {
      return data.hpcode;
    } else {
      const targetCountry = bcl.contextHub.getItem("profile", "country_code");
      if (!targetCountry && !bcl.c.header.language) {
        return;
      }

      const $associateSelect = document.querySelector("." + bcl.c.header.language.props.classNameAssociateSelect + "[data-country=" + targetCountry.toLowerCase() + "]");
      if (!$associateSelect) {
        return;
      }
      const currentLanguage = document.getElementsByClassName(this.props.classLanguageDialog)[0].getAttribute(this.props.locale);
      let $targetLanguage = currentLanguage ? $associateSelect.querySelector("option[data-language=" + currentLanguage.toLowerCase() + "]") : "";
      if (!$targetLanguage) {
        $targetLanguage = $associateSelect.querySelector("option[data-default-language=true]");
      }
      if (!$targetLanguage) {
        $targetLanguage = $associateSelect.getElementsByTagName("option")[0];
      }
      return $targetLanguage?.dataset.hpCode;
    }
  },

  initCurrentItem: function ($element, data) {
    $element.addEventListener("click", (e) => {
      e.preventDefault();
      if (bcl.modal.props.$modal) {
        bcl.modal.props.$modal.close();
      }
      if (data && data.currentHpcode) {
        this.setCookie(this.href, data.currentHpcode);
      }
    });
  },

  initSelectItem: function ($element) {
    if (!$element) {
      return;
    }

    $element.addEventListener("click", (e) => {
      e.preventDefault();

      if (bcl.modal.props.$modal) {
        bcl.modal.props.$modal.close();
      }

      if (this.props.$languageSelection) {
        bcl.s.tabs.props.clickInContainer = true;
        this.props.$languageSelection.click();
      }
    });
  },

  setCookie: function (path, language) {
    bcl.cookie.set("bhg_keep_nav", true, path);
    if (language) {
      localStorage.setItem("barcelo_language", language);
    }
  },
};

export default languageDialog;
